import React, { useState } from "react";
import style from "../changeRequest/ChangeRequest.module.scss";
import Chevron from "../../assets/svg/Chevron.svg";
import ChevronUp from "../../assets/svg/ChevronUp.svg";
import { formatSequenceNumber } from "../../helpers/utils.js";
import SafeHtml from "../../components/safeHtml/SafeHtml.jsx";
import { dateOnlyFormatted, getAccountCurrency, displayDecimalFormatted } from "../../utils/systemSettings.js";
import { CircleCheck, CircleAlert, CircleX } from "lucide-react";
import { Tooltip } from "@fluentui/react-components";

const InvoiceItem = ({ item }) => {
  const [show, setShow] = useState(false);
  const settings = JSON.parse(localStorage.getItem("settings"));

  const handleToggle = () => {
    setShow(!show);
  };

  return (
    <div className={`${style.mainWrapper} mb-3`}>
      <div className={`${style.headerWrapper} w-100`} onClick={handleToggle}>
        <div className="d-flex w-50">
          <div className={`${style.inlinePills} d-flex justify-content-between`}>

            <div className="d-flex align-items-center">
              <Tooltip content={item.isInLedger ? "In Ledger" : "Not In Ledger"} relationship="label">
                {item.isInLedger
                  ? <CircleCheck size={16} color="#5aa55a" />
                  : <CircleX size={16} color="#d1424f" />
                }
              </Tooltip>
            </div>

            <Tooltip content={"Sequence #"} relationship="label">
              <span className={`${style.badgeLabel}`}>{formatSequenceNumber("InvoiceEntry", item.sequenceNumber)}</span>
            </Tooltip>
            <Tooltip content={"Account"} relationship="label">
              <p className="text-md-600 ms-2 mb-0">{item.account}</p>
            </Tooltip>

          </div>
        </div>
        <div className={`${style.gapsBetweeen} d-flex`}>
          <div className={`${style.riskPills}`}>
            <div className={`${style.riskPill}`}>
              <div className={`${style.riskPillContent}`}>
                <label className="text-xsm-600 grey10Color mb-1">Invoice Date</label>
                <span className={`pill secondary ${style.riskPillOverride}`}>{dateOnlyFormatted(settings, item.date) || "-"}</span>
              </div>
            </div>
            <div className={`${style.riskPill}`}>
              <div className={`${style.riskPillContent}`}>
                <label className="text-xsm-600 grey10Color mb-1">Paid Date</label>
                <span className={`pill ${item.paidDate ? 'Completed' : 'secondary'} ${style.riskPillOverride}`}>{dateOnlyFormatted(settings, item.paidDate) || "-"}</span>
              </div>
            </div>
            <div className={`${style.riskPill}`}>
              <div className={`${style.riskPillContent}`}>
                <label className="text-xsm-600 grey10Color mb-1">Value Before Tax</label>
                <span className={`pill secondary ${style.riskPillOverride}`}>{getAccountCurrency(settings)} {displayDecimalFormatted(settings, item.valueBeforeTax)}</span>
              </div>
            </div>
          </div>
          <img
            className={`${style.arrowleftGap}`}
            src={show ? ChevronUp : Chevron}
            alt=""
          />
        </div>
      </div>

      {show && (
        <div className={style.riskItemWrapper}>
          <div className={style.riskItemBlockDates}>
            <div className={style.riskItemMeta}>
              <h6 className={style.riskItemTitle}>Payment Code:</h6> {item.cashflowLineItem?.lineDescription ? item.cashflowLineItem.lineDescription : ''}
            </div>
            <div className={style.riskItemMeta}>
              <h6 className={style.riskItemTitle}>Supplier Inv #:</h6> {item.supplierInvId}
            </div>
            <div className={style.riskItemMeta}>
              <h6 className={style.riskItemTitle}>Internal Inv #:</h6> {item.internalInvId}
            </div>
          </div>

          {item.comments && (
            <div className={style.riskItemBlock}>
              <h6 className={style.riskItemTitle}>Comments</h6>
              <p className={style.riskItemDescription}>
                <SafeHtml html={item.comments} />
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default InvoiceItem;
